import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment.prod";
import { response } from '../common/interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient, 
  ) { }

  getUsers(status){
    let params : HttpParams = new HttpParams().set('active', status);
    return this.http.get<response>(environment.url +"users", { params : params});
  }

  saveUser(user){
    return this.http.post<response>(environment.url +"users", user);
  }

  updateUser(id, user){
    return this.http.put<response>(environment.url +"users/"+id, user);
  }

  updateUserPermission(id, permission){
    return this.http.put<response>(environment.url +"users/permission/"+id, permission);
  }

  getUser(id){
    return this.http.get<response>(environment.url  + "users/"+id);
  }

  deleteUser(id){
    return this.http.delete<response>(environment.url  + "users/"+id);
  }

  getSigninDatas(workingDate){
    return this.http.get<response>(environment.url +"signin/"+workingDate);
  }

  getSigninData(id){
    return this.http.get<response>(environment.url +"signin/"+id);
  }

  updateSignInData(id, data){
    return this.http.put<response>(environment.url +"signin/"+id, data);
  }

  searchAttendance(data){
    return this.http.post<response>(environment.url +"signin/searchsigin", data);
  }


}
